const createDefaultConfiguration = () => ({
    title: 'Importer Status Widget',
    importerUuids: [],
})

export default createDefaultConfiguration
